<script setup>
import { computed, toRefs } from 'vue';

import Button from 'primevue/button';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import useSpacing from '@/composables/useSpacing';

const props = defineProps(['settings', 'icon']);

const { settings } = toRefs(props);

const { padding } = useSpacing(settings);
const backgroundColor = computed(() => settings?.value?.backgroundColor ?? 'var(--button-bg-color)');
const textColor = computed(() => settings?.value?.textColor ?? 'var(--button-text-color)');
const fontFamily = computed(() => `'${settings?.value?.font}'` ?? 'var(--button-font-family)');
const borderRadius = computed(() => `${settings?.value?.borderRadius ?? 'var(--button-radius)'}px`);
const textSize = computed(() => `${settings?.value?.textSize ?? 'var(--button-text-size)'}px`);
const icon = computed(() => settings?.value?.icon ?? props.icon);

const text = computed(() => settings?.value?.text ?? 'Button');
const href = computed(() => settings?.value?.href ?? '');
const target = computed(() => settings?.value?.target ?? '_self');

</script>

<template>
  <div class="element button-element">
    <a
      v-if="href"
      :href="href"
      :target="target"
    >
      <Button
        class="button"
        :label="text"
        severity='primary'
        :icon="icon?.prefix?.startsWith('fa') ? undefined : icon"
        :data-test="`pages-button-${text}`"
      >
        <template
          #icon
          v-if="icon?.prefix?.startsWith('fa')"
        >
          <FontAwesomeIcon :icon="icon" class="mr-2" />
        </template>
      </Button>
    </a>

    <Button
      v-else
      class="button"
      :label="text"
      severity='primary'
      :icon="icon?.prefix?.startsWith('fa') ? undefined : icon"
      :data-test="`pages-button-${text}`"
    >
      <template
        #icon
        v-if="icon?.prefix?.startsWith('fa')"
      >
        <FontAwesomeIcon :icon="icon" class="mr-2" />
      </template>
    </Button>
  </div>
</template>

<style scoped>
.button-element {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: v-bind(padding);
}

.button {
  background: v-bind(backgroundColor);
  color: v-bind(textColor);
  font-family: v-bind(fontFamily);
  border-radius: v-bind(borderRadius);
  font-size: v-bind(textSize);
}
</style>
